module.exports = __webpack_public_path__ + "img/icon-like-checked.7806bda0.svg";